'use client';

import { INavListItem } from '@/api/types/public';
import MagicJump from '@/components/MagicJump';
import { useReporting } from '@/hooks/useReporting';
import { useRouteMetadata } from '@/hooks/useRouteMetadata';
import { useStore } from '@/providers/app-store-provider';
import { ProviderType } from '@/reporting';
import { setSession } from '@/utils/tools';
import styles from './index.module.scss';

interface TextNavProps {
  item: INavListItem;
  firstLevelIndex: number;
  firstLevelTitle: string; // 一级菜单标题
  secondLevelIndex: number; // 所属的二级菜单索引
  isLast: boolean; // 是否是最后一个
  isDarkMode?: boolean;
}

const TextNav = ({
  item,
  firstLevelIndex,
  firstLevelTitle,
  secondLevelIndex,
  isLast,
  isDarkMode = false,
}: TextNavProps) => {
  const { trackEvent } = useReporting();
  const { cnName } = useRouteMetadata();
  const setIsOpenSideNav = useStore((state) => state.setIsOpenSideNav);
  const isMobileScreen = useStore((state) => state.isMobileScreen);
  if (!item.content) return null;

  const handleBeforeJump = (title: string, index: number) => {
    setSession('zl_goodsListEnterPageScene', '全局导航');
    setIsOpenSideNav(false);
    trackEvent(
      {
        eventName: isMobileScreen ? 'SideNavBarTab_Click' : 'TopNavigationTab_Click',
        properties: {
          page_name: cnName,
          url_path: window.location.href,
          tab_name: firstLevelTitle, // 一级菜单标题
          tab_index: firstLevelIndex, // 一级菜单索引
          first_level_category: (item.content as any).layout_title, // 神策埋点定义的二级菜单标题
          second_level_category: title, // 神策埋点定义的三级菜单标题
          first_level_index: secondLevelIndex,
          second_level_index: index,
        },
      },
      [ProviderType.SENSORS],
    );
  };
  const jumpTarget = {
    jump_type: item.content.jump_type || 0,
    Jump_target: item.content.Jump_target || '',
    product_group: {
      id: item.content.product_group?.id,
      path: (item.content as any).product_group?.path,
    },
    sku: {
      shop_sku: (item.content as any).sku?.shop_sku,
    },
    crowd_recommend: {
      id: (item.content as any).crowd_recommend?.id,
    },
  };
  return (
    <div
      className={`${styles.textNavPc} ${isDarkMode ? 'md:text-[#fff] md:bg-[#131415] ' : 'text-[#282828] md:bg-white'}  pt-[16px] pb-[4px] bg-[#fafafa]   md:pt-0 md:pb-[16px] lg:pb-[4px] lg:pt-[16px] md:flex md:flex-col  md:items-start ${isLast ? 'pb-[24px] lg:pb-[60px]' : ''}`}
    >
      {/* 二级标题 */}
      <MagicJump
        className={`${styles.secondTitle} ${isDarkMode ? 'text-[#fff]' : 'text-[#282828]'} text-[14px] font-bb block py-[7px] px-[28px] md:mb-[12px] lg:mb-0 lg:text-[18px] lg:leading-[22px]  md:border-transparent md:hover:border-primary-black md:inline-block md:p-0`}
        item={jumpTarget}
      >
        {(item.content as any).layout_title}
      </MagicJump>

      {/* 三级列表项 */}
      {(item.content as any).list?.map((cItem, idx) => (
        <MagicJump
          key={cItem.id}
          className={`text-[13px] block py-[8px] px-[28px] lg:text-[16px] lg:leading-[20px] md:border-b md:border-transparent md:hover:border-primary-black md:px-0 md:mt-[16px] md:mb-[8px] lg:mb-0 lg:mt-0 md:text-[14px] md:inline-block md:p-0 ${
            idx < (item.content as any).list.length - 1 ? styles.thirdItem : ''
          }`}
          item={{
            jump_type: cItem.jump_type,
            Jump_target: cItem.Jump_target,
            product_group: {
              id: cItem.product_group?.id,
              path: cItem.product_group?.path,
            },
            sku: {
              shop_sku: cItem.sku?.shop_sku,
            },
            crowd_recommend: {
              id: cItem.crowd_recommend?.id,
            },
          }}
          onBeforeJump={() => handleBeforeJump(cItem.title, idx)}
        >
          {cItem.title}
        </MagicJump>
      ))}
    </div>
  );
};

export default TextNav;
